import React from 'react';
import { AccordionBodyItem } from 'component/Accordion';
import { CheckboxInput } from 'component/Checkbox';

export const AntiPersonnelMines = (props) => {
  const hazardType = props.formData.info.hazard_type;

  return (
    <AccordionBodyItem
      accordionSubId="3.1"
      titleUA="Протипіхотні міни"
      titleEN="Anti-personnel mine"
      className={props.errors.hazard_type ? 'error' : ''}
      children={(
        <CheckboxInput
          id="antiPersonnelMines"
          name="anti_personnel_mines"
          value="anti_personnel_mines"
          checked={hazardType.anti_personnel_mines}
          handleInput={props.handleContamination}
          disabled={props.formData.info.general.hazard_type.includes('battlefield')}
        />
      )}
    />
  );
};
